import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_ALIGN = {
  Left: "left",
  Right: "right",
  Center: "center",
} as const;

export type DSAlign = ObjectValues<typeof DS_ALIGN>;
